// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-link-items[data-v-42e0bece]{-moz-column-count:2;column-count:2;-moz-column-gap:15px;column-gap:15px}.footer-link-items .link-items[data-v-42e0bece]{font-size:14px;padding:8px 0;margin:0}@media (max-width:767px){.footer-link-items[data-v-42e0bece]{-moz-column-count:1;column-count:1}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
